export class SecurityDataDTO {

  public requireNewPassword: boolean;

}